import { Link } from 'react-router-dom';
import { Film } from '../common/Icons';
import { useLanguage } from '../../lib/LanguageContext';
import AdBanner from '../common/AdBanner';

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="bg-surface-950 border-t border-surface-800/50 mt-16">
      <div className="max-w-7xl mx-auto px-4 py-6 flex justify-center">
        <AdBanner placement="footer" />
      </div>
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Film className="text-primary" size={24} />
              <span className="text-lg font-bold">
                <span className="text-primary">Cine</span>Verse
              </span>
            </Link>
            <p className="text-sm text-surface-500 leading-relaxed">
              Your ultimate destination for movie and TV show discovery. Track what you watch, save favorites, and explore new content.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-3">{t('browse')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/movies/popular" className="text-sm text-surface-500 hover:text-white transition-colors">
                  {t('movies')}
                </Link>
              </li>
              <li>
                <Link to="/tvshows/popular" className="text-sm text-surface-500 hover:text-white transition-colors">
                  {t('tvShows')}
                </Link>
              </li>
              <li>
                <Link to="/articles" className="text-sm text-surface-500 hover:text-white transition-colors">
                  {t('articles')}
                </Link>
              </li>
              <li>
                <Link to="/calendar" className="text-sm text-surface-500 hover:text-white transition-colors">
                  {t('releaseCalendarFooter')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-3">{t('account')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/favorites" className="text-sm text-surface-500 hover:text-white transition-colors">
                  {t('favorites')}
                </Link>
              </li>
              <li>
                <Link to="/watchlist" className="text-sm text-surface-500 hover:text-white transition-colors">
                  {t('watchlist')}
                </Link>
              </li>
              <li>
                <Link to="/history" className="text-sm text-surface-500 hover:text-white transition-colors">
                  {t('watchHistory')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-3">{t('legal')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-sm text-surface-500 hover:text-white transition-colors">
                  {t('termsOfService')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-surface-500 hover:text-white transition-colors">
                  {t('privacyPolicy')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-surface-800/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-surface-600">
            &copy; {new Date().getFullYear()} CineVerse. {t('allRightsReserved')}
          </p>
          <p className="text-xs text-surface-600">
            {t('poweredBy')}
          </p>
        </div>
      </div>
    </footer>
  );
}
